module.exports = __webpack_public_path__ + "static/media/icon_csv.a4f018b9.svg";